import { buildMeta } from "../lib/seo.js";
import ContactPage from "../components/ContactPage/ContactPage.jsx";

const PAGE = {
  title: "Request a Demo",
  description:
    "See Road Safety Audit 3D and 3D Visualization on your own project data. Request a live demo.",
  path: "/demo",
};

const STEPS = [
  {
    title: "We reply within one business day",
    text: "To agree a time, and the corridor or design to use.",
  },
  {
    title: "A live demo on your project",
    text: "We walk you through the analyses or the model with your data, and answer questions as we go.",
  },
  {
    title: "A straight answer",
    text: "What we can do for your project, and what it would take.",
  },
];

export function meta() {
  return buildMeta(PAGE);
}

export default function Demo() {
  return (
    <ContactPage
      title="Request a demo"
      lead="See Road Safety Audit 3D or 3D Visualization working on a project like yours: a corridor that needs auditing, or a design the public needs to see."
      steps={STEPS}
      interest="demo"
      path={PAGE.path}
    />
  );
}
